export const expiredCokkieInDay = 14;
export enum StorageItems {
  FIRSTTIMELOGIN = "FirstTimeLogin",
  TOKEN = "token",
  EMAIL = "Email",
  AssetView = "ASSETVIEW",
  PASSWORD = "Password",
  TicketView = "TICKETVIEW",
  ONBOARDSTEP = "OnBoardStep",
  SELECTEDCOMPONENTS = "SelectedComponents",
  REFRESHTOKEN = "refreshToken",
  UPDATEEMAIL = "UpdateEmail",
  OLDPASSWORD = "OldPassword",
  APPLANGUAGE = "appLanguage",
  CONFIRMATIONTOKEN = "ConfirmationToken",
  PreviousLocation = "PreviousLocation",
  // page
  TicketPage = "TicketPage",
  AssetPage = "AssetPage",
  PurchasePage = "PurchasePage",
  IncidentPage = "IncidentPage",
  //pagesize
  TicketPageSize = "TicketPageSize",
  AssetPageSize = "AssetPageSize",
  PurchasePageSize = "PurchasePageSize",
  IncidentPageSize = "IncidentPageSize",
  PurchaseRequestSize = "PurchaseRequestSize",
  PurchaseRequestPageSize = "PurchaseRequestPageSize",
}
